module.exports = __webpack_public_path__ + "static/hero-23f31ba688b1b7dec4cab6c2fad66873.png";